import { Component, OnInit, ViewChild, ViewContainerRef, TemplateRef } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDataService } from '../../Services/MasterDataService';
import { ShiftSetupDepartmentData, ShiftDetails } from '../../Models/ResponseModels';
import { ShiftSetUpService } from '../../Services/ShiftSetUpService';
import { ShiftSetUpModel, StaffAssignmentFilter, SaveShiftResponse, StaffSkill, GetDepartmentDataRequest, DeleteShiftRequest } from '../../Models/RequestModels';
import { SkillLookup, LanguageLookup, PropertyBasicInfo, DepartmentMaster } from '../../Models/GlobalEntities';

import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EntityCodes, ShiftSetupLoadOptions } from '../../Models/EnumModels';
import { UserService } from '../../Services/UserService';
import { Department } from '../Department/Department';
import * as _ from 'lodash';
import * as alasql from 'alasql';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogService, SimpleModalComponent } from 'ngx-modal-dialog';
import {AppSettings} from "../../Library/AppSettings";

@Component({
    selector: 'ShiftSetUp',
    templateUrl: './ShiftSetUp.html',
})

export class ShiftSetUp extends BaseComponent implements OnInit {
    @ViewChild('department') department: Department;
    @ViewChild('content') content;
    @ViewChild('activateShift') activateShift;
    @ViewChild('shiftSetupKey') shiftSetupKey;
    @ViewChild('sectionContainer', { read: ViewContainerRef }) sectionContainer: ViewContainerRef;
    @ViewChild('sectionItem', { read: TemplateRef }) sectionItemTemplate: TemplateRef<any>;

    ModalRef: NgbModalRef;
    ModalRef1: NgbModalRef;
    ShiftResponseModel: ShiftSetupDepartmentData;
    shiftList: Array<any>;
    Model: ShiftSetUpModel;
    DepartmentDataRequestModel: GetDepartmentDataRequest;
    skillList: Array<SkillLookup> = [];
    sectionList: Array<SkillLookup> = [];
    saveShiftResponse: SaveShiftResponse;
    deptList: Array<DepartmentMaster> = [];
    SectionSkillStaffData: Array<any> = [];
    AllStaffList: Array<any> = [];
    ClonedAllStaffList: Array<any> = [];
    LanguageList: Array<LanguageLookup>;
    IsShiftRenamed: boolean = false;
    MultiLingualShiftData: Array<any> = [];
    DisableModalOpenEvent: boolean = false;
    PropertyList: Array<PropertyBasicInfo>;
    SingleStaffId: number;
    UnmappedSection: Array<number>;
    columnWidth: number;
    IsShiftCopied: boolean = false;
    StartAllCollapsed = false;
    SectionRendered = { showProgress: false, progress: 0 };
    ShiftSetupLoadOptions = ShiftSetupLoadOptions;
    AppSettings = AppSettings;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected modalService: NgbModal, protected shiftSetUpService: ShiftSetUpService, protected userService: UserService, private modalDialogService: ModalDialogService, private viewContainer: ViewContainerRef) {
        super(translate, toastr, route, router, masterService);

    }

    ngOnInit(): void {
        this.PropertyList = this.GetProperties_Action(this._AuthActionCodes.ShiftSetupview);
        this.Model = new ShiftSetUpModel();
        if (this.PropertyList.length > 0) {
            if (this.PropertyList.findIndex(a => a.PropertyId == this.masterService.ActivePropertyID) >= 0)
                this.Model.PropertyId = this.masterService.ActivePropertyID;
            else
                this.Model.PropertyId = this.PropertyList[0].PropertyId;
        }

        this.SetDefault();
        this.department.Open(this.Model);
    }

    PropertyChanged(event): void {
        let CurrentProperty = this.Model.PropertyId;
        let confirmText = this.translate.instant('LBL.CONFIRM_CHANGE_LOSS');
        this.OpenConfirmationModal(confirmText, cbyes => {
            this.Model.PropertyId = +event.target.value;
            this.SetDefault();
            this.shiftList = [];
            this.SectionSkillStaffData = [];
        }, cbno => this.PropertyUnchangedCallBack(+CurrentProperty));
    }

    PropertyUnchangedCallBack(CurrentProperty) {
        this.Model.PropertyId = _.assign(CurrentProperty);
    }

    DeptChanged(event): void {
        let CurrentDept = this.Model.DeptId;
        let confirmText = this.translate.instant('LBL.CONFIRM_CHANGE_LOSS');
        if (this.Model.DeptId) {
            this.OpenConfirmationModal(confirmText, cbyes => {
                this.Model.DeptId = +event.target.value;
                this.Model.ShiftId = null;
                this.GetShiftDetail();
            }, cbno => this.DeptUnchangedCallback(+CurrentDept));
        }
        else {
            this.Model.DeptId = +event.target.value;
            this.Model.ShiftId = null;
            this.GetShiftDetail();
        }
    }

    DeptUnchangedCallback(CurrentDept) {
        this.Model.DeptId = _.assign(CurrentDept);
    }

    SetDefault(): void {
        this.Model.ShiftId = null;
        this.Model.IsNewShift = false;
        this.Model.ShiftName = '';
        this.Model.DeptId = 0;
        this.Model.PerShiftSkillEnabled = ShiftSetupLoadOptions.CommonSkills;
        this.saveShiftResponse = new SaveShiftResponse();
        this.saveShiftResponse.PropertyId = this.Model.PropertyId;
        this.ShiftResponseModel = new ShiftSetupDepartmentData();
        this.DepartmentDataRequestModel = new GetDepartmentDataRequest();
        let Dept = this.masterService.Cache_PropertyMainMasters.getValue(this.Model.PropertyId).Dept;
        this.deptList = Dept.filter(obj => this.CheckAuth_Dept_Action(this.Model.PropertyId, obj.Id, this._AuthActionCodes.ShiftSetupview) == true);
        this.deptList = this.deptList.filter(obj => obj.IsServiceDepartment === true);
        this.LanguageList = this.masterService.GetLanguage(this.Model.PropertyId);
    }

    SetShiftRequest(data: ShiftSetUpModel): void {
        this.Model = _.cloneDeep(data);
        this.GetShiftDetail();
    }

    ShiftChange(event) {
        let CurrentShift = this.Model.ShiftId;
        let confirmText = this.translate.instant('LBL.CONFIRM_CHANGE_LOSS');
        this.OpenConfirmationModal(confirmText, cbyes => {
            this.Model.ShiftId = +event.target.value;
            this.GetShiftDetail();
        }, cbno => {
            this.Model.ShiftId = _.assign(+CurrentShift);
        });
    }

    ShiftSkillOptionChange(event) {
        if (!event || !event.target) {
            return;
        }
        const newOption = event.target.value == ShiftSetupLoadOptions[ShiftSetupLoadOptions.ShiftSkills]
            ? ShiftSetupLoadOptions.ShiftSkills
            : ShiftSetupLoadOptions.CommonSkills;

        const currentOption = this.Model.PerShiftSkillEnabled;
        let confirmText = this.translate.instant('LBL.CONFIRM_CHANGE_LOSS');
        this.OpenConfirmationModal(confirmText, cbyes => {
            this.Model.PerShiftSkillEnabled = newOption;
            const useDefaultSkills = newOption != ShiftSetupLoadOptions.ShiftSkills;
            this.rebuildShiftSetup(useDefaultSkills);

        }, cbno => this.ShiftSkillOptionUnchange(currentOption));
    }

    ShiftSkillOptionUnchange(PerShiftSkillEnabled) {
        this.Model.PerShiftSkillEnabled = _.assign(PerShiftSkillEnabled) ;
    }


    GetShiftDetail() {
        this.Model.IsNewShift = false;
        this.IsShiftRenamed = false;
        this.Model.DeptName = this.masterService.Cache_PropertyMainMasters.getValue(this.Model.PropertyId).Dept.find(x => x.Id == this.Model.DeptId).Name;
        this.DepartmentDataRequestModel.PropertyId = this.Model.PropertyId;
        this.DepartmentDataRequestModel.DeptId = this.Model.DeptId;
        if (this.Model.ShiftId == 0) {
            this.DepartmentDataRequestModel.ShiftId = null;
        } else {
            this.DepartmentDataRequestModel.ShiftId = this.Model.ShiftId;
        }

        this.GetAllSkills();
        this.GetAllSections();

        Promise.all([this.shiftSetUpService.GetShiftDetails(this.DepartmentDataRequestModel), this.GetStaffData()])
            .then((data) => {

                let [shiftData, staffData] = data;
                if (shiftData && shiftData.HasError) {
                    this.GetMultilingualToast(shiftData.Errors[0].ErrorMessage, 'error')
                    return
                }

                if (shiftData && shiftData.Result) {
                    this.ShiftResponseModel = shiftData.Result;

                    const currentLanguage = this.masterService.LoggedInUserData.LanguageCode;
                    const createShiftDetailMap = (shiftDetails: ShiftDetails[], langCode: string) => {
                        return shiftDetails
                            .filter(item => item.LanguageCode == langCode)
                            .reduce((acc, item) => {
                                if (!acc[item.ShiftId]) {
                                    acc[item.ShiftId] = [];
                                }
                                acc[item.ShiftId].push(item);
                                return acc;
                            }, {})
                    }
                    const shiftsForCurrentLanguage = createShiftDetailMap(this.ShiftResponseModel.AllShifts, currentLanguage);
                    const shiftsForEng = createShiftDetailMap(this.ShiftResponseModel.AllShifts, 'ENG');

                    if (this.ShiftResponseModel.CurrentShift != null) {
                        let list = shiftsForCurrentLanguage[this.ShiftResponseModel.CurrentShift.ShiftId];
                        if (list && list.length > 0) {
                            this.Model.ShiftName = list[0].ShiftName;
                            this.Model.PerShiftSkillEnabled = list[0].PerShiftSkillEnabled
                                ? ShiftSetupLoadOptions.ShiftSkills
                                : ShiftSetupLoadOptions.CommonSkills;
                        }
                        else {
                            this.Model.ShiftName = this.ShiftResponseModel.CurrentShift.ShiftName;
                            this.Model.PerShiftSkillEnabled = this.ShiftResponseModel.CurrentShift.PerShiftSkillEnabled
                                ? ShiftSetupLoadOptions.ShiftSkills
                                : ShiftSetupLoadOptions.CommonSkills;
                        }
                        if (this.Model.ShiftId) {
                            this.Model.ShiftId = this.ShiftResponseModel.CurrentShift.ShiftId;
                        }
                        else {
                            this.Model.ShiftId = 0;
                        }

                    } else {
                        this.Model.ShiftName = '';
                        this.Model.ShiftId = null;
                    }

                    let shiftList = Object.keys(shiftsForEng).map(shiftId => (shiftsForCurrentLanguage[shiftId] || shiftsForEng[shiftId])[0]);
                    this.shiftList = shiftList;
                    let _i = this.shiftList.findIndex(obj => obj.ShiftId == 0);
                    if (_i >= 0) {
                        this.shiftList[_i].IsActive = "(Active)";
                    }

                    this.rebuildShiftSetup();
                }
            });
    }


    private rebuildShiftSetup(useDefaultSkills = false) {
        const MaxShiftStaff = 500;

        this.CreateResponseData(useDefaultSkills);
        this.ModifyStaffList();
        this.CreateGridData(useDefaultSkills);

        // calculate number of staff entries and use that as a measure to open or collapse all sections
        this.StartAllCollapsed = (this.SectionSkillStaffData || []).reduce((acc1, section) => {
            acc1 += (section.Skills || []).reduce((acc2, skill) => {
                acc2 += (skill.Staff || []).length;
                return acc2;
            }, 0)
            return acc1
        }, 0) > MaxShiftStaff;
        this.ToggleAllSection(!this.StartAllCollapsed)
        // start manual render
        this.buildSections();
    }

    private buildSections() {
        const totalSections = (this.SectionSkillStaffData || []).length
        const itemRenderedAtOnce = 3;
        const intervalInMS = 10;
        let currentIndex = 0;
        this.sectionContainer.clear();
        this.SectionRendered = { showProgress: true, progress: 0 };
        const interval = setInterval(() => {
            const nextIndex = currentIndex + itemRenderedAtOnce;
            for (let n = currentIndex; n < nextIndex; n++) {
                if (n >= totalSections) {
                    clearInterval(interval);
                    this.SectionRendered = { showProgress: false, progress: 0 };
                    break;
                }
                const context = {
                    section: this.SectionSkillStaffData[n],
                    index1: n
                }

                this.sectionContainer.createEmbeddedView(this.sectionItemTemplate, context);
            }
            currentIndex += itemRenderedAtOnce;
            this.SectionRendered.progress = Math.ceil((currentIndex * 100) / totalSections);
        }, intervalInMS);

    }

    GetStaffData(): Promise<Array<any>> {
        let req = new StaffAssignmentFilter();
        req.PropertyId = this.Model.PropertyId;
        req.AllPropertyCallCount = true;
        req.IncluedAllstaff = true;
        return this.userService.Staff_ForAssignment(req).then(data => {
            if (data) {
                this.AllStaffList = data;
                this.AllStaffList = this.AllStaffList.filter((item) => {
                    return (item.DeptId == this.Model.DeptId)
                });
                this.ClonedAllStaffList = _.cloneDeep(this.AllStaffList);
                return this.ModifyStaffList();
            }
            return;
        });
    }

    GetSkillName(skillIds) {
        let arrlen = skillIds.length;
        if (skillIds && arrlen > 0) {
            let SkillName = "";

            for (let i = 0; i < arrlen; i++) {
                SkillName += this.masterService.MasterData_GetMutli(this.Model.PropertyId, skillIds[i], EntityCodes.Skill, "");
                if (i < (arrlen - 1)) {
                    SkillName += ', ';
                }
            }
            SkillName = SkillName.replace(/,$/, '');
            return SkillName;
        }
        return;
    }

    GetSectionName(sectionIds) {
        let arrlen = sectionIds.length;
        if (sectionIds && arrlen > 0) {
            let SectionName = "";
            for (let i = 0; i < arrlen; i++) {
                SectionName += this.masterService.MasterData_GetMutli(this.Model.PropertyId, sectionIds[i], EntityCodes.Sections, "");
                if (i < (arrlen - 1)) {
                    SectionName += ', ';
                }
            }
            SectionName = SectionName.replace(/,$/, '');
            return SectionName;
        }
        return;
    }

    GetAllSkills(): void {
        let SkillLookup = this.masterService.GetPropertyCache(this.Model.PropertyId);
        if (SkillLookup) {
            this.skillList = [];
            let skillList = SkillLookup.Skill.filter(item => item.DeptId == this.Model.DeptId);
            if(skillList && skillList.length) {
                skillList.forEach(SkillObj => {
                    if(this.checkSkillWithCategory(SkillObj)){
                        this.skillList.push(SkillObj);
                    }
                })
            }
            this.columnWidth = Math.floor(100 / (this.skillList.length + 1));
        }
    }

    GetAllSections(): void {
        let SectionLookup = this.masterService.GetSections(this.Model.PropertyId);
        if (SectionLookup) {
            //this.sectionList = SectionLookup.Sections.filter(item => item.DeptId == this.Model.DeptId);
            let query = "Select * From ? Where DeptId = " + this.Model.DeptId + " Order By Name asc";
            this.sectionList = alasql(query, [SectionLookup]);
        }
    }

    CreateGridData(useDefaultSkills = false): void {
        this.SectionSkillStaffData = [];
        const listShiftStaff =
            (useDefaultSkills ? this.ShiftResponseModel.DefaultStaffSkills : this.ShiftResponseModel.ListShiftStaff) || [];

        this.sectionList.forEach(SectionItem => {
            let SectionSkillStaffObj: any = {};
            SectionSkillStaffObj = _.cloneDeep(SectionItem);
            SectionSkillStaffObj.Skills = [];
            SectionSkillStaffObj.isOpen = true;
            this.skillList.forEach(SkillItem => {
                let SkillObj: any = {};
                SkillObj = _.cloneDeep(SkillItem);
                if (listShiftStaff.length) {
                    let StaffDataList = []
                    StaffDataList = listShiftStaff.filter((StaffItem) => (StaffItem.SectionId == SectionItem.Id && (StaffItem.Skills.indexOf(SkillItem.Id)) != -1));
                    StaffDataList.forEach(obj => {
                        if (this.ShiftResponseModel.ListStaffDevices.findIndex(item => item.StaffId == obj.StaffId) >= 0) {
                            obj.HasDevices = true;
                        }
                        else obj.HasDevices = false;
                        let StaffSectionMap = [];
                        StaffSectionMap = this.saveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == obj.StaffId);
                        if (StaffSectionMap.length > 1) {
                            obj.MultipleSections = true;
                        }
                        else
                            obj.MultipleSections = false;
                    })

                    SkillObj.Staff = StaffDataList;

                }
                else {
                    SkillObj.Staff = [];
                }
                if(this.checkSkillWithCategory(SkillObj)){
                    SectionSkillStaffObj.Skills.push(SkillObj);
                }
            });

            let UnSkillObj: any = {};
            UnSkillObj.Id = -1;
            UnSkillObj.Name = 'Unskilled';
            let UnSkilledStaff = [];
            UnSkilledStaff = listShiftStaff.filter(StaffObj => StaffObj.SectionId == SectionItem.Id && StaffObj.Skills.length == 0);

            if (UnSkilledStaff.length > 0) {
                UnSkilledStaff.forEach(obj => {
                    if (this.ShiftResponseModel.ListStaffDevices.findIndex(item => item.StaffId == obj.StaffId) >= 0) {
                        obj.HasDevices = true;
                    }
                    else obj.HasDevices = false;
                    let StaffSectionMap = [];
                    StaffSectionMap = this.saveShiftResponse.SectionStaffMapping.filter(item => item.StaffId == obj.StaffId);
                    if (StaffSectionMap.length > 1) {
                        obj.MultipleSections = true;
                    }
                    else
                        obj.MultipleSections = false;
                });

                UnSkillObj.Staff = _.cloneDeep(UnSkilledStaff);
            }
            else UnSkillObj.Staff = [];
            if (this.checkSkillWithCategory(UnSkillObj) || UnSkillObj.Id == -1 ){
            SectionSkillStaffObj.Skills.push(UnSkillObj);
            }
            this.SectionSkillStaffData.push(SectionSkillStaffObj);
        });
    }

    checkSkillWithCategory(SkillObj: any): boolean {
        let categories = this.masterService.GetCallCategories(this.Model.PropertyId);
        let keyByCategories = _.keyBy(categories, 'SkillId');
        return keyByCategories[SkillObj.Id] ? true : false;
    }

    CreateResponseData(useDefaultSkills = false): void {
        this.saveShiftResponse = new SaveShiftResponse();
        this.saveShiftResponse.PropertyId = this.Model.PropertyId;
        this.saveShiftResponse.DeptId = this.Model.DeptId;

        if (this.ShiftResponseModel.CurrentShift != null) {
            this.saveShiftResponse.PerShiftSkillEnabled = this.ShiftResponseModel.CurrentShift.PerShiftSkillEnabled;
            this.saveShiftResponse.Notes = this.ShiftResponseModel.CurrentShift.Notes;
            this.saveShiftResponse.ShiftId = this.ShiftResponseModel.CurrentShift.ShiftId;
            this.saveShiftResponse.ShiftName = this.ShiftResponseModel.CurrentShift.ShiftName;
            if (this.ShiftResponseModel.CurrentShift.ShiftId == this.ShiftResponseModel.ActiveShiftId) {
                this.saveShiftResponse.IsShiftActivated = true;
            }
        }

        const listShiftStaff = (useDefaultSkills ? this.ShiftResponseModel.DefaultStaffSkills : this.ShiftResponseModel.ListShiftStaff) || [];
        this.saveShiftResponse.MultiLingualShiftNameAndNotes = this.ShiftResponseModel.AllShifts.filter((item) =>
            (item.ShiftId == this.Model.ShiftId));
            listShiftStaff.forEach(row => {
            let staffSection = {} as any;
            staffSection.SectionId = row.SectionId;
            staffSection.StaffId = row.StaffId;

            this.saveShiftResponse.SectionStaffMapping.push(staffSection);

            let staffSkill = new StaffSkill();
            staffSkill.Skills = row.Skills;
            staffSkill.StaffId = row.StaffId;
            if (_.findIndex(this.saveShiftResponse.ListStaffSkills, { 'StaffId': row.StaffId }) == -1)
                this.saveShiftResponse.ListStaffSkills.push(staffSkill)

        })
        // this.saveShiftResponse.ListStaffDevices = _.cloneDeep(this.ShiftResponseModel.ListStaffDevices)

    }

    GetStaffListOfSection(SectionId: number, SkillId: number) {
        if (SkillId) {
            return this.ShiftResponseModel.ListShiftStaff.filter(item => (item.SectionId == SectionId && (item.Skills.indexOf(SkillId) != -1)))
        }
        else {
            return this.ShiftResponseModel.ListShiftStaff.filter(item => item.SectionId == SectionId)
        }
    }

    GetStaffName(StaffId: number): string {
        return this.masterService.MasterData_GetMutli(this.Model.PropertyId, StaffId, EntityCodes.Staff, "")
    }

    ToggleAllSection(open: boolean): void {
        this.SectionSkillStaffData.forEach(row => {
            row.isOpen = open;
        })
    }

    GetStaffStatusIcon(Staff: any): string {
        let StaffSectionMap = [];
        StaffSectionMap = this.saveShiftResponse.SectionStaffMapping.filter(obj => obj.StaffId == Staff.StaffId);
        if (StaffSectionMap.length > 1) {
            return "fas fa-user-friends fa-fw";
        }
        else
            return "fas fa-user fa-fw";
    }

    SaveShift(): void {
        if (this.CheckUnmappedSections()) {
            let confirmText = this.translate.instant('LBL.CONTINUE_UNMAPPED_SKILL_SECTION');
            this.OpenConfirmationModal(confirmText, cbYes => this.CheckShiftNameExist(), cbNo => { });
        }
        else {
            this.CheckShiftNameExist();
        }
    }

    CheckShiftNameExist() {
        if (this.saveShiftResponse.ShiftName == '') {
            this.OpenNewShiftModal();
        }
        else {
            this.OpenShiftActivationModal();
        }
    }

    OpenShiftActivationModal(): void {
        if (this.DisableModalOpenEvent) return;
        //this.saveShiftResponse.IsShiftActivated = null;
        let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            centered: true
        };
        this.ModalRef1 = this.modalService.open(this.activateShift, ngbModalOptions);
        this.DisableModalOpenEvent = true;
        this.ModalRef1.result.then((result) => {
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }

    ActivateAndSave(activateShift: boolean) {
        if (activateShift)
            this.saveShiftResponse.IsShiftActivated = true;
        else
            this.saveShiftResponse.IsShiftActivated = false;
        this.SendShiftToServer(cb => {
            if (activateShift)
                this.GetMultilingualToast('TS.TS_SHIFT_SAVE_ACTIVATE_SUCCESS', 'success');
            else
                this.GetMultilingualToast('TS.TS_SHIFT_SAVE_SUCCESS', 'success');
            this.GetShiftDetail()
        });
    }

    validateShiftActivation(): void {
        this.ClearErrors();
        if (this.saveShiftResponse.IsShiftActivated == null) {
            this.AddError('ERR.ERR_SELECT_1_OPTION');
        }
        else {
            this.SendShiftToServer(cb => {
                this.GetMultilingualToast('TS.TS_SHIFT_SAVE_SUCCESS', 'success');
                this.GetShiftDetail()
            });
        }
    }

    SaveAsShift(): void {
        this.IsShiftCopied = true;
        this.OpenNewShiftModal();
    }

    AddNameToShift(): void {
        if (this.Validate()) {
            if (!this.IsShiftRenamed && !this.Model.IsNewShift) {
                if (this.Model.ShiftId == null || this.IsShiftCopied) {
                    this.saveShiftResponse.ShiftId = null;
                }
                this.IsShiftCopied = false;
                //if ((!this.ShiftResponseModel.ActiveShiftId || this.ShiftResponseModel.ActiveShiftId != this.Model.ShiftId)) {
                if (this.ModalRef) this.ModalRef.close();
                if (this.CheckAuth_Dept_Action(this.Model.PropertyId, this.Model.DeptId, this._AuthActionCodes.ShiftActivate))
                    this.OpenShiftActivationModal();
                else
                    this.SendShiftToServer(cb => {
                        this.GetMultilingualToast('TS.TS_SHIFT_SAVE_SUCCESS', 'success');
                        this.GetShiftDetail();
                    });
            }
            if (this.Model.IsNewShift && !this.IsShiftRenamed) {
                this.Model.ShiftId = null;
                this.SectionSkillStaffData = [];
                this.ShiftResponseModel.ListShiftStaff = [];
                this.saveShiftResponse = new SaveShiftResponse();
                this.saveShiftResponse.PropertyId = this.Model.PropertyId;
                this.saveShiftResponse.DeptId = this.Model.DeptId;
                this.CreateGridData();
                this.AllStaffList = _.cloneDeep(this.ClonedAllStaffList);
                this.ModifyStaffList();
            }
            const Shift_Eng = this.MultiLingualShiftData.find(obj => obj.LanguageCode == "ENG");
            this.saveShiftResponse.ShiftName = Shift_Eng ? Shift_Eng.ShiftName : '';
            this.Model.ShiftName = this.saveShiftResponse.ShiftName;
            this.saveShiftResponse.Notes = Shift_Eng ? Shift_Eng.Notes : '';
            this.saveShiftResponse.MultiLingualShiftNameAndNotes = this.MultiLingualShiftData;
            if (this.IsShiftRenamed) {
                this.shiftList.find(obj => obj.ShiftId == this.Model.ShiftId).ShiftName = this.Model.ShiftName;
            }
            this.IsShiftRenamed = false;
            this.ModalRef.close();
        }
    }

    Validate(): boolean {
        this.ClearErrors();
        let HasError: boolean = false;
        for (let i = 0; i < this.MultiLingualShiftData.length; i++) {
            let Obj = this.MultiLingualShiftData[i];
            if (Obj.ShiftName != "")
                Obj.ShiftName = Obj.ShiftName.trim();

            if (Obj.ShiftName == "") {
                this.AddError('ERR.ERR_ENTER_SHIFT_NAME');
                HasError = true;
                break;
            }

            if (Obj.ShiftName.length > 50) {
                this.AddError('ERR.ERR_SHIFT_NAME_LENGTH_50');
                HasError = true;
                break;
            }
            if (this.Model.ShiftId && this.ShiftResponseModel.AllShifts.findIndex(item => item.ShiftName == Obj.ShiftName && this.Model.ShiftId != item.ShiftId) >= 0) {
                this.AddError('ERR.ERR_DUPLICATE_SHIFT_NAME');
                HasError = true;
                break;
            }
            else if ((this.Model.IsNewShift || (!this.IsShiftRenamed && !this.Model.IsNewShift)) && this.ShiftResponseModel.AllShifts.findIndex(item => item.ShiftName == Obj.ShiftName) >= 0) {
                this.AddError('ERR.ERR_DUPLICATE_SHIFT_NAME');
                HasError = true;
                break;
            }
        }

        if (HasError)
            return false;
        else
            return true;
    }

    SendShiftToServer(cb): void {
        if (this.saveShiftResponse.ShiftId == 0) {
            this.saveShiftResponse.ShiftId = this.ShiftResponseModel.ActiveShiftId;
        }
        this.saveShiftResponse.PerShiftSkillEnabled = this.Model.PerShiftSkillEnabled === ShiftSetupLoadOptions.ShiftSkills;
        this.shiftSetUpService.SaveShiftDetails(this.saveShiftResponse)
            .then(data => {
                if (this.ModalRef) {
                    this.ModalRef.close();
                }
                if (this.ModalRef1) {
                    this.ModalRef1.close();
                }
                if (!data.HasError) {
                    cb();
                }
                else {
                    this.GetMultilingualToast(data.Errors[0].ErrorMessage, 'error')
                }

            })
    }

    CreateNewShift() {
        if (this.ShiftResponseModel.AllShifts.length > 0) {
            let confirmText = this.translate.instant('LBL.CONFIRM_CHANGE_LOSS');
            this.OpenConfirmationModal(confirmText, cbYes => {
                this.Model.IsNewShift = true;
                this.Model.PerShiftSkillEnabled = ShiftSetupLoadOptions.CommonSkills;
                this.OpenNewShiftModal();
            }, cbNo => { });
        }
        else {
            this.Model.IsNewShift = true;
            this.Model.PerShiftSkillEnabled = ShiftSetupLoadOptions.CommonSkills;
            this.OpenNewShiftModal();
        }

    }

    OpenNewShiftModal() {
        this.ClearErrors();
        this.MultiLingualShiftData = [];
        this.LanguageList.forEach((language) => {
            let Obj: any = {};
            let index = this.saveShiftResponse.MultiLingualShiftNameAndNotes.findIndex(obj => obj.LanguageCode == language.LanguageCode);
            if (this.IsShiftRenamed && index >= 0) {
                Obj.LanguageCode = language.LanguageCode;
                Obj.ShiftName = this.saveShiftResponse.MultiLingualShiftNameAndNotes[index].ShiftName;
                Obj.Notes = this.saveShiftResponse.MultiLingualShiftNameAndNotes[index].Notes;

            }
            else {
                Obj.LanguageCode = language.LanguageCode;
                Obj.ShiftName = "";
                Obj.Notes = "";
            }
            this.MultiLingualShiftData.push(Obj);
        })
        let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            size: 'lg',
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
        this.ModalRef.result.then((result) => {
        }, (reason) => { this.IsShiftRenamed = false; this.Model.IsNewShift = false; });

    }

    DeleteShift(data: any): void {
        let req: DeleteShiftRequest = new DeleteShiftRequest();
        req.DeptId = this.Model.DeptId;
        req.PropertyId = this.Model.PropertyId;
        req.ShiftId = this.Model.ShiftId;
        this.shiftSetUpService.DeleteShift(req).then(data => {
            if (data && data.Result) {
                this.Model.ShiftId = null;
                this.GetShiftDetail();
            }
        })
    }

    EditShiftName(): void {
        this.IsShiftRenamed = true;
        this.OpenNewShiftModal();
    }

    UpdateDeviceData(staffId: number): void {
        this.SectionSkillStaffData.forEach(Section => {
            Section.Skills.forEach(Skill => {
                //let arr = this.MappedStaff.filter((row) => (row.Sections.indexOf(Section.Id) >= 0 && row.Skills.indexOf(Skill.Id) >= 0));
                let index = Skill.Staff.findIndex(obj => obj.StaffId == staffId);

                if (this.ShiftResponseModel.ListStaffDevices.findIndex(item => item.StaffId == staffId) >= 0) {
                    this.AllStaffList.find(obj => obj.StaffId == staffId).HasDevices = true;
                    if (index >= 0) Skill.Staff[index].HasDevices = true;
                }
                else {
                    this.AllStaffList.find(obj => obj.StaffId == staffId).HasDevices = false;
                    if (index >= 0) Skill.Staff[index].HasDevices = false;
                }

            })
        });
    }

    UpdateStaff(staffLst: any): void {
        staffLst.forEach(staff => {
            let index = this.AllStaffList.findIndex(obj => obj.StaffId == staff.StaffId);
            if (index >= 0) {
                this.AllStaffList[index].IsLoggedIn = staff.LoginStatus;
                this.AllStaffList[index].AllOpenCalls = staff.AllOpenCalls;
                this.AllStaffList[index].OpenCalls = staff.OpenCalls;
            }
            this.SectionSkillStaffData.forEach(Section => {
                Section.Skills.forEach(Skill => {
                    let index = Skill.Staff.findIndex(obj => obj.StaffId == staff.StaffId);
                    if (index >= 0) {
                        Skill.Staff[index].IsLoggedIn = staff.LoginStatus;
                    }
                })
            });
        })

    }

    Refresh(): void {
        let confirmText = this.translate.instant('LBL.CONFIRM_CHANGE_LOSS');
        this.OpenConfirmationModal(confirmText, cbYes => this.GetShiftDetail(), cbNo => { });
    }

    OpenConfirmationModal(confirmText, cbYes, cbNo): void {
        let confirmTitle = this.translate.instant('TITLE.TITLE_PLEASE_CONFIRM');
        let btnYes = this.translate.instant('BTN.BTN_YES');
        let btnNo = this.translate.instant('BTN.BTN_NO');

        this.modalDialogService.openDialog(this.viewContainer, {
            title: confirmTitle,
            childComponent: SimpleModalComponent,
            settings: {
                closeButtonClass: 'close theme-icon-close'
            },
            data: {
                text: confirmText
            },
            actionButtons: [
                {
                    text: btnYes,
                    buttonClass: 'btn btn-primary',
                    onAction: () => {
                        cbYes();
                        return true;
                    }
                },
                {
                    text: btnNo,
                    buttonClass: 'btn btn-secondary',
                    onAction: () => {
                        cbNo();
                        return true;
                    }
                },
            ]
        });
    }

    ModifyStaffList() {
        // use default-staff-skills from GetDepartmentData response
        // because when 'common skills' are selected and we are adding new staff,
        // its skills show up as empty because of
        // a) ListStaffSkills might itself be empty ie new-shift
        // b) we are not relying on Staff_ForAssignment's skill data
        const staffSkillsToUse = (this.Model && this.Model.PerShiftSkillEnabled == ShiftSetupLoadOptions.ShiftSkills)
            ? this.saveShiftResponse.ListStaffSkills
            : this.ShiftResponseModel.DefaultStaffSkills;

        return this.AllStaffList.map((row) => {
            const staffSkill = _.find<StaffSkill>(staffSkillsToUse, { 'StaffId': row.StaffId }) // || row.Skills || new StaffSkill();
            if (staffSkill) {
              row.Skills = _.cloneDeep(staffSkill.Skills || [])
            }

            row.SkillName = this.GetSkillName(_.uniq(row.Skills));
            row.Sections = [];

            let StaffSections = this.saveShiftResponse.SectionStaffMapping.filter(obj => obj.StaffId == row.StaffId);
            StaffSections.forEach(SectionStaffObj => {
                row.Sections.push(SectionStaffObj.SectionId);
            })
            if (StaffSections.length > 1) {
                row.MultipleSections = true;
            }
            else
                row.MultipleSections = false;
            if (this.ShiftResponseModel.ListStaffDevices && this.ShiftResponseModel.ListStaffDevices.findIndex(obj => obj.StaffId == row.StaffId) >= 0) {
                row.HasDevices = true;
            }
            else row.HasDevices = false;

            row.SectionName = this.GetSectionName(_.uniq(row.Sections));
            row.AllOpenCalls = row.AllOpenCalls || 0;
            return row;
        });
    }

    CheckUnmappedSections(): boolean {
        this.UnmappedSection = [];
        this.SectionSkillStaffData.forEach(section => {
            let index = section.Skills.findIndex(a => a.Id != -1 && a.Staff.length == 0);
            if (index >= 0) {
                this.UnmappedSection.push(section.Id);
            }
        })
        //this.UnmappedSection = this.UnmappedSection.filter(a => a != -1);
        if (this.UnmappedSection.length > 0)
            return true;
        else
            return false;
    }

    OpenKeyModal(): void {
        let ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            size: 'lg',
            centered: true
        };
        this.modalService.open(this.shiftSetupKey, ngbModalOptions);
    }

    //TrackByStaff(index, section): number {
    //    return section.Id;
    //}

}
